<template>
 <div   class="nav-column">
   <h6 class="bav-column-title" >{{navTitle}}</h6>
   <div class="nav-column-wrapper">
     <h6 v-for="(text, key) in menuText" :key="key">{{text}}</h6>

   </div>

 </div>
</template>

<script>
 export default {
  name: 'NavColumn',
   props: {
    navTitle: String,
     menuText: {
       type: Array
     },
   }

 }
</script>

<style lang="scss">
@import "NavColumn";
</style>
